import React, { Component } from 'react';
import axios from "axios";

import api from '../../api/api';

import Modal from "./Modal"

import ParadigmaTable from "../../components/ParadigmaTable/ParadigmaTable"

class TipoEventos extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: "nombre",
                    show: true,
                },
                {
                    Header: "Color de Fondo",
                    id: "backgroundColor",
                    className:"text-center",
                    accessor: d => (
                         d.backgroundColor ?
                         <div style={{height: '100%'}}>
                         <div className="btn py-0" style={{height: '80%', background: `#${d.backgroundColor}`, width: 30,  marginRight: 10,}}/>
                          {d.backgroundColor}
                          </div>
                          :
                          ('')
                    ),
                    width: 200,
                    show: true,
                },
                {
                    Header: "Color de Texto",
                    id: "color",
                    className:"text-center",
                    accessor: d => (
                         (d.color) ?
                         <div style={{height: '100%'}}>
                          <div className="btn py-0" style={{ background: `#${d.color}`, width: 30, height: '80%', marginRight: 10, }} />
                          {d.color}
                          </div>
                         :
                         ('')
                     ),
                    width: 200,
                    show: true,
                },
                {
                    Header: "Habilitado",
                    id: "habilitado",
                    className:"text-center",
                    accessor: d => (d.habilitado) ? ('Si') : ('No'),
                    width: 200,
                    show: true,
                },
            ]
        };
    }
    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        component: (props) => <Modal {...props} action="CREATE" />,
                        permission: 'tipo_eventos_new',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="EDIT" />,
                        permission: 'tipo_eventos_edit',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DETAIL" />,
                        permission: 'tipo_eventos_detail',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DELETE" />,
                        permission: 'tipo_eventos_delete',
                    }
                ]}
                apiUrl={api.calendar.tipoEventos}
                columns={this.state.columns}
                exportUrl={api.calendar.tipoEventos}
                title={"Tipos de Eventos"}
            />
        );
    }
}

export default TipoEventos;



// WEBPACK FOOTER //
// ./src/views/TipoEventos/TipoEventos.js